export default "__VITE_ASSET__CnuHymR6__"